import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { TUserFull } from '../../types';
import { denormalize } from 'normalizr';
import { userNormSchema } from '../normSchema/users';

const selectCollectionsState = (state: RootState) => ({
  users: state.units.users,
  userCards: state.units.userCards,
  roles: state.access.roles,
});

const selectMeID = (state: RootState) => state.access.me;

export const selectMe = createSelector(
  [selectCollectionsState, selectMeID],
  (collections, uuid): TUserFull | undefined => {
    if (!uuid) return;
    const user = collections.users[uuid];
    if (!user) return;
    return denormalize(uuid, userNormSchema, collections);
  },
  {
    memoizeOptions: {
      resultEqualityCheck: (prev: TUserFull | undefined, next: TUserFull | undefined) => {
        if (!prev || !next) return prev === next;
        return JSON.stringify(prev) === JSON.stringify(next);
      },
    },
  }
);
